import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import localization from "services/localization";
import CustomSelect from "views/Components/CustomSelect";
import ClipLoader from "react-spinners/ClipLoader";
import ReactDatePicker from "react-datepicker";

import { useSchoolsStore } from "context/useSchoolsStore";

export default function AddEditUserModal({
  isOpen,
  onClose,
  onSave,
  formData,
  onChange,
  loading,
  errors,
  title,
}) {
  const { schools } = useSchoolsStore();
  const [role, setRole] = useState(null);
  const [selectedSchools, setSelectedSchools] = useState([]);

  const roles = [
    { value: "teacher", label: "Teacher" },
    { value: "student", label: "Student" },
    { value: "administrative", label: "Administration" },
    { value: "root", label: "Super Admin" },
  ];

  useEffect(() => {
    if (formData?.role) {
      const selected = roles.find((r) => r.value === formData.role);
      setRole(selected || null);
    }
  }, [formData]);

  const handleSelectChange = (field, selectedOption) => {
    setRole(selectedOption);
    onChange({
      target: { name: field, value: selectedOption?.value || "" },
    });
  };

  const handleChange = (field, value) => {
    onChange({
      target: { name: field, value: value },
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(formData);
  };

  const schoolOptions = schools?.map((school) => ({
    value: school.id,
    label: school.name,
  }));

  //   useEffect(() => {
  //   if (formData?.school_id && schoolOptions.length) {
  //     const mapped = schoolOptions.filter((opt) =>
  //       formData.school_id.some((s) => s == opt.value)
  //     );

  //     setSelectedSchools(mapped);
  //   }
  // }, [formData, schoolOptions]);

  return (
    <Modal
      show={isOpen}
      onHide={onClose}
      centered
      className="themed-modal bootstrapModal"
    >
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>

      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          {/* Full Name */}
          <Form.Group className="mb-3 required" controlId="formName">
            <Form.Label className="bootstrap-label">
              {localization.full_name || "Full Name"}
            </Form.Label>
            <Form.Control
              type="text"
              name="name"
              value={formData.name || ""}
              onChange={onChange}
              placeholder="e.g., Jennifer Di Marco"
              isInvalid={!!errors.name}
            />
            <Form.Control.Feedback type="invalid">
              {errors.name}
            </Form.Control.Feedback>
          </Form.Group>

          {/* Email */}
          <Form.Group className="mb-3 required" controlId="formEmail">
            <Form.Label className="bootstrap-label">
              {localization.email || "Email"}
            </Form.Label>
            <Form.Control
              type="email"
              name="email"
              value={formData.email || ""}
              onChange={onChange}
              placeholder="e.g., jennifer@school.edu"
              isInvalid={!!errors.email}
            />
            <Form.Control.Feedback type="invalid">
              {errors.email}
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group className="mb-3 required" controlId="birthdate">
            <Form.Label className="bootstrap-label">
              {localization.birthdate || "Birthdate"}
            </Form.Label>

            <Form.Control
              type="date"
              name="birthdate"
              value={formData.birthdate || ""}
              onChange={(e) => handleChange("birthdate", e.target.value)}
              placeholder="YYYY-MM-DD"
              isInvalid={!!errors.birthdate}
            />
            {/* <ReactDatePicker
              selected={formData.birthdate ? new Date(formData.birthdate) : null}
              name="birthdate"
              onChange={(date) => {
                if (!date) return;

                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, "0");
                const day = String(date.getDate()).padStart(2, "0");
                const formatted = `${year}-${month}-${day}`;

                handleChange("birthdate", formatted);
              }}
              dateFormat="yyyy-MM-dd"
              placeholderText="Pick a date"
              className={`w-full bg-background border px-3 py-2 rounded-md text-sm ${
                errors.birthdate ? "border-red-500 is-invalid" : "border-border"
              }`}
              wrapperClassName="w-full"
            /> */}

            {errors.birthdate && (
              <div className="invalid-feedback d-block">{errors.birthdate}</div>
            )}
          </Form.Group>

          {/* Role */}
          <Form.Group className="mb-3 required" controlId="formRole">
            <Form.Label className="bootstrap-label">
              {localization.user_role || "User Role"}
            </Form.Label>
            <CustomSelect
              value={role}
              onChange={(val) => handleSelectChange("role", val)}
              options={roles}
              classNamePrefix="react-select"
            />
          </Form.Group>

          <Form.Group className="mb-3" controlId="formSchools">
            <Form.Label className="bootstrap-label">
              {localization.organizations || "Organizations"}
            </Form.Label>
            <CustomSelect
              isMulti
              value={schoolOptions.filter((opt) =>
                formData?.school_id?.includes(opt.value),
              )}
              options={schoolOptions}
              onChange={(selected) => {
                console.log(
                  "Selected schools:",
                  selected.map((s) => s.value),
                );
                onChange({
                  target: {
                    name: "school_id",
                    value: selected.map((s) => s.value),
                  },
                });
              }}
              classNamePrefix="react-select"
            />
          </Form.Group>

          {/* <Form.Group className="mb-3" controlId="formPassword">
            <Form.Label>Password</Form.Label>
            <Form.Control
              type="password"
              name="password"
              value={formData.password || ""}
              onChange={onChange}
              placeholder="Enter password"
              isInvalid={!!errors.password}
            />
            <Form.Control.Feedback type="invalid">
              {errors.password}
            </Form.Control.Feedback>
          </Form.Group> */}
        </Modal.Body>

        <Modal.Footer>
          <Button className="action-btn secondary" onClick={onClose}>
            {localization.cancel || "Cancel"}
          </Button>
          <Button
            className="action-btn primary no-border"
            type="submit"
            disabled={loading}
          >
            {loading ? (
              <ClipLoader color="var(--primary-icon)" size={20} />
            ) : (
              localization.save || "Save"
            )}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}
